const styles = (theme) => ({
  checkbox: {
    cursor: 'pointer',
    padding: 4,
  },
  disabled: {
    color: `${theme.palette.neutral.light} !important`,
  },
});

export default styles;
